import React from "react";
import "./index.css";

import image1 from "../../images/1.jpg";
import image2 from "../../images/2.jpg";
import image3 from "../../images/3.jpg";

const Header = () => {
    return (
        <div className="header">
            <img src={image1} alt="" />
            <img src={image2} alt="" />
            <img src={image3} alt="" />
        </div>
    );
}

export default Header;


// WEBPACK FOOTER //
// ./src/presentational/Header/index.js